import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { alpha, styled } from '@mui/material/styles';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import { Box } from '@mui/material';
import { normalizeTrimmedValue, shouldTrimFieldValue } from '@ui/components/common/TextField/text-input-normalize';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const StyledFilledTextField = styled((props) => (_jsx(TextField, { variant: 'filled', ...props })))(({ theme }) => {
    const fillBackground = REGISTRATION_FIELD_FILL_BG;
    return {
        '& .MuiFilledInput-root': {
            backgroundColor: fillBackground,
            borderRadius: 14,
            boxShadow: 'none',
            border: `1px solid ${alpha(theme.palette.common.grey.main, 0.12)}`,
            '&:before, &:after': { display: 'none' },
            '& input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
                WebkitTextFillColor: 'inherit',
                transition: 'background-color 5000s ease-in-out 0s'
            },
            '& input:-webkit-autofill:focus': {
                WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
                WebkitTextFillColor: 'inherit'
            },
            '&.Mui-focused': {
                backgroundColor: fillBackground,
                boxShadow: 'none'
            },
            '&:hover': {
                backgroundColor: fillBackground
            },
            paddingLeft: 8,
            '&.MuiFilledInput-multiline': {
                paddingLeft: 19
            }
        },
        '& .MuiInputLabel-root': {
            fontWeight: 400,
            color: theme.palette.common.grey.dark,
            left: 8
        },
        '& .MuiFormHelperText-root': {
            marginLeft: 8
        }
    };
});
const EFilledTextField = ({ name, control, label, rules, error, multiline, rows, fieldType, tooltipText, trimWhitespace = true, disabled, type, ...rest }) => {
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [label, tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText]);
    const handlePhoneChange = (e, field) => {
        if (fieldType === '3') {
            let value = e.target.value;
            value = value.replace(/[^0-9+\-\s]/g, '');
            if (value.includes('+')) {
                const plusIndex = value.indexOf('+');
                if (plusIndex > 0) {
                    value = '+' + value.replace(/\+/g, '');
                }
                value = '+' + value.replace(/\+/g, '');
            }
            field.onChange(value);
            return;
        }
        if (shouldTrimFieldValue(type, trimWhitespace)) {
            const normalized = normalizeTrimmedValue(e.target.value, Boolean(multiline), 'change');
            if (normalized !== e.target.value) {
                field.onChange({
                    ...e,
                    target: { ...e.target, value: normalized },
                    currentTarget: { ...e.currentTarget, value: normalized }
                });
                return;
            }
        }
        field.onChange(e);
    };
    const handleBlur = (e, field) => {
        if (fieldType !== '3' && shouldTrimFieldValue(type, trimWhitespace)) {
            const normalized = normalizeTrimmedValue(e.target.value, Boolean(multiline), 'blur');
            if (normalized !== e.target.value) {
                field.onChange(normalized);
            }
        }
        field.onBlur();
    };
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsxs(Box, { width: '100%', children: [_jsx(StyledFilledTextField, { ...field, ...rest, label: styledLabel, error: !!error, disabled: disabled, fullWidth: true, type: type, multiline: multiline, rows: rows, onChange: (e) => handlePhoneChange(e, field), onBlur: (e) => handleBlur(e, field) }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] })) }));
};
export default EFilledTextField;
